<template>
    <div class="container mx-auto px-4" v-if="Object.keys(user).length > 0">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ user.prefix }} {{ user.lastname }} {{ user.firstname }}</h1>

        <div class="mb-8 md:gap-8 md:grid md:grid-cols-2">
            <div class="flex flex-col md:items-center">
                <h2 class="font-semibold mb-8 uppercase">{{ __('Belépési adatok') }}</h2>

                <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="email" required type="email"
                                v-bind:invalid="!!requestStore.errors?.email || (user.email.length > 0 && !validEmail)"
                                v-bind:label="__('E-mail cím')"
                                v-bind:placeholder="__('placeholders.email')"
                                v-model="user.email"
                                v-on:keyup="validateEmail"
                />
                <span class="px-1 text-error text-xs" v-if="user.email.length > 0 && !validEmail">
                    {{ __('Az email cím formátuma nem megfelelő.') }}
                </span>

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password" placeholder="**********" type="password"
                                v-bind:invalid="!!requestStore.errors?.password || (password.length > 0 && password.length < 8)"
                                v-bind:label="__('Jelszó')"
                                v-model="password"
                />
                <span class="px-1 text-error text-xs" v-if="password.length > 0 && password.length < 8">
                    {{ __('A jelszó legalább :length karakterből kell álljon.', { 'length' : 8 }) }}
                </span>

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password_confirmation" placeholder="**********" type="password"
                                v-bind:invalid="!!requestStore.errors?.password_confirmation || (password.length > 0 && password !== passwordConfirmation)"
                                v-bind:label="__('Jelszó újra')"
                                v-model="passwordConfirmation"
                />
                <span class="px-1 text-error text-xs" v-if="password.length > 0 && password !== passwordConfirmation">
                    {{ __('A jelszavak nem egyeznek.') }}
                </span>
            </div>

            <div class="flex flex-col md:items-center md:mt-0 mt-8">
                <h2 class="font-semibold mb-8 uppercase">{{ __('Személyes adatok') }}</h2>

                <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="prefix" type="text"
                                v-bind:invalid="!!requestStore.errors?.prefix"
                                v-bind:label="__('Előtag')"
                                v-bind:placeholder="__('placeholders.prefix')"
                                v-model="user.prefix"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="lastname" required type="text"
                                v-bind:invalid="!!requestStore.errors?.lastname"
                                v-bind:label="__('Vezetéknév')"
                                v-bind:placeholder="__('placeholders.lastname')"
                                v-model="user.lastname"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="firstname" required type="text"
                                v-bind:invalid="!!requestStore.errors?.firstname"
                                v-bind:label="__('Keresztnév')"
                                v-bind:placeholder="__('placeholders.firstname')"
                                v-model="user.firstname"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="phone" required type="text"
                                v-bind:invalid="!!requestStore.errors?.phone"
                                v-bind:label="__('Telefonszám')"
                                v-bind:placeholder="__('placeholders.phone')"
                                v-model="user.phone"
                />
            </div>
        </div>

        <div v-if="user.group?.is_webshop_enabled">
            <h2 class="font-semibold mb-8 uppercase">{{ __('Számlázási adatok') }}</h2>

            <div class="md:gap-8 md:grid md:grid-cols-2 mb-8">
                <div class="flex flex-col md:items-center">
                    <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="billing_name" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.billing_name"
                                    v-bind:label="__('Számlázási név')"
                                    v-model="user.billing_name"
                    />

                    <c-control-select class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="country" required
                                      v-bind:invalid="!!requestStore.errors?.country"
                                      v-bind:label="__('Ország')"
                                      v-bind:options="countries"
                                      v-model="user.country"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="city" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.city"
                                    v-bind:label="__('Település')"
                                    v-model="user.city"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="address_1" required rows="2" type="textarea"
                                    v-bind:invalid="!!requestStore.errors?.address_1"
                                    v-bind:label="__('Címsor 1')"
                                    v-model="user.address_1"
                    />
                </div>

                <div class="flex flex-col items-center">
                    <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="tax_id" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.tax_id"
                                    v-bind:label="__('Adószám')"
                                    v-model="user.tax_id"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="postcode" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.postcode"
                                    v-bind:label="__('Irányítószám')"
                                    v-model="user.postcode"
                                    v-on:update:model-value="updateCityAndCounty"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="county" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.county"
                                    v-bind:label="__('Megye')"
                                    v-model="user.county"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="address_2" rows="2" type="textarea"
                                    v-bind:invalid="!!requestStore.errors?.address_2"
                                    v-bind:label="__('Címsor 2')"
                                    v-model="user.address_2"
                    />
                </div>
            </div>
        </div>

        <div class="flex items-center justify-center mb-4 mt-8 mx-auto">
            <a class="block cursor-pointer mr-10 underline"
               v-on:click="isDeleted = true"
            >
                {{ __('Fiók törlése') }}
            </a>

            <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                      v-bind:disabled="user.firstname.length === 0 || user.lastname.length === 0 || user.phone.length === 0 || !validEmail || (password.length > 0 && password.length < 8) || (password.length > 0 && password !== passwordConfirmation)"
                      v-on:click="submit"
            >
                {{ __('Mentés') }}
            </c-button>
        </div>
    </div>

    <c-modal class="md:w-[450px]" v-bind:open="isDeleted" v-bind:title="__('Fiók törlése')" v-on:closeModal="isDeleted = false">
        <template v-slot:body>
            <div class="py-5 text-center text-sm">
                {{ __('Biztosan törölni szeretnéd a fiókodat? Adataid anonimizálva lesznek és a folyamat nem visszafordítható.') }}
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end w-full">
                <c-button class="bg-slate-100 mr-2 text-slate-800" v-on:click="isDeleted = false">
                    {{ __('Mégsem') }}
                </c-button>

                <c-button class="bg-error text-white" v-on:click="del">
                    {{ __('Törlés') }}
                </c-button>
            </div>
        </template>
    </c-modal>
</template>

<script setup lang="ts">
    import { inject, onMounted, ref } from 'vue';
    import {
        CButton,
        CControlSelect,
        CControlText,
        CModal,
    } from '@teamfurther/cinderblock';
    import UserRepository from '../../repositories/UserRepository';
    import { useGeoStore } from "../../stores/geo";
    import { useRequestStore } from '../../stores/request';
    import { useSessionStore } from '../../stores/session';

    const __ = inject('__');
    const countries = ref([]);
    const geoStore = useGeoStore();
    const isDeleted = ref(false);
    const password = ref('');
    const passwordConfirmation = ref('');
    const sessionStore = useSessionStore();
    const user = ref<object>(sessionStore.user);
    const userRepository = new UserRepository();
    const requestStore = useRequestStore();
    const validEmail = ref<boolean>(true);

    async function del() {
        await userRepository.destroy(user.value.id);

        sessionStore.logUserOut();
    }

    async function submit() {
        user.value.password = password.value;
        user.value = await userRepository.update(user.value.id, user.value, {
            include: ['group']
        });

        password.value = '';
        passwordConfirmation.value = '';

        sessionStore.refreshUser();
    }

    function validateEmail() {
        validEmail.value = !!user.value.email.match(/\S+@\S+\.\S+/);
    }

    onMounted(async () => {
        countries.value = await geoStore.countries();
        countries.value.unshift({
            disabled: true,
            label: '---',
            value: null,
        });
        countries.value.unshift({
            label: __('country.HU'),
            value: 'HU',
        });
    });
</script>
